
































import {Component, Vue} from 'vue-property-decorator'
import {Action, Mutation} from 'vuex-class'
import {Task} from '@/store/types'

import AppHeader from '@/components/common/AppHeader.vue'
import SurveyListItem from './SurveyListItem.vue'
import SurveyModel from '@/classes/SurveyModel'

@Component({
  components: {
    AppHeader,
    SurveyListItem,
  },
})
export default class SurveyAttentionList extends Vue {
  @Action('getTaskList') public getTaskList: any
  @Mutation('setLoader') public setLoader!: any

  public taskCompletedList: Task[] = []
  public taskCanceledList: Task[] = []

  public created() {
    this.setLoader(true)
    this.getTaskList([`status=${SurveyModel.STATUS.COMPLETED}`])
      .then((response: Task[]) => {
        this.taskCompletedList = response
        this.setLoader(false)
      })

    this.getTaskList([`status=${SurveyModel.STATUS.CANCELED}`])
      .then((response: Task[]) => this.taskCanceledList = response)
  }

  public back() {
    this.$router.back()
  }
}
